import React from 'react';
import { getTenantTierLabel } from '../../../utils/utils';

const GoldIcon = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M15.9995 2.68799C23.374 2.68799 29.3118 8.62507 29.312 15.9995C29.312 23.3742 23.3742 29.312 15.9995 29.312C8.62507 29.3118 2.68799 23.374 2.68799 15.9995C2.68824 8.62522 8.62522 2.68824 15.9995 2.68799ZM13.437 12.7505L6.87451 13.2505L11.8745 17.563L10.3745 23.9995L15.9995 20.6255L21.6255 23.9995L20.1255 17.563L25.1255 13.2505L18.563 12.688L15.9995 6.68799L13.437 12.7505Z"
      fill="url(#paint0_linear_58_17)"
    />
    <defs>
      <linearGradient id="paint0_linear_58_17" x1="16" y1="2.68799" x2="16" y2="29.312" gradientUnits="userSpaceOnUse">
        <stop offset="0.168269" stopColor="#FFD53E" />
        <stop offset="0.951923" stopColor="#FF7802" />
      </linearGradient>
    </defs>
  </svg>
);

const SilverIcon = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M15.9995 2.68799C23.374 2.68799 29.3118 8.62507 29.312 15.9995C29.312 23.3742 23.3742 29.312 15.9995 29.312C8.62507 29.3118 2.68799 23.374 2.68799 15.9995C2.68824 8.62522 8.62522 2.68824 15.9995 2.68799ZM13.437 12.7505L6.87451 13.2505L11.8745 17.563L10.3745 23.9995L15.9995 20.6255L21.6255 23.9995L20.1255 17.563L25.1255 13.2505L18.563 12.688L15.9995 6.68799L13.437 12.7505Z"
      fill="url(#paint0_linear_58_19)"
    />
    <defs>
      <linearGradient id="paint0_linear_58_19" x1="16" y1="2.68799" x2="16" y2="29.312" gradientUnits="userSpaceOnUse">
        <stop offset="0.25" stopColor="#B5D5E9" />
        <stop offset="1" stopColor="#C9AFEA" />
      </linearGradient>
    </defs>
  </svg>
);

const BronzeIcon = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M15.9995 2.68799C23.374 2.68799 29.3118 8.62507 29.312 15.9995C29.312 23.3742 23.3742 29.312 15.9995 29.312C8.62507 29.3118 2.68799 23.374 2.68799 15.9995C2.68824 8.62522 8.62522 2.68824 15.9995 2.68799ZM13.437 12.7505L6.87451 13.2505L11.8745 17.563L10.3745 23.9995L15.9995 20.6255L21.6255 23.9995L20.1255 17.563L25.1255 13.2505L18.563 12.688L15.9995 6.68799L13.437 12.7505Z"
      fill="url(#paint0_linear_58_21)"
    />
    <defs>
      <linearGradient id="paint0_linear_58_21" x1="16.0052" y1="2.68799" x2="16.0026" y2="29.312" gradientUnits="userSpaceOnUse">
        <stop offset="0.293269" stopColor="#F9978A" />
        <stop offset="1" stopColor="#C9AFEA" />
      </linearGradient>
    </defs>
  </svg>
);

const BaseIcon = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M15.9995 2.68799C23.374 2.68799 29.3118 8.62507 29.312 15.9995C29.312 23.3742 23.3742 29.312 15.9995 29.312C8.62507 29.3118 2.68799 23.374 2.68799 15.9995C2.68824 8.62522 8.62522 2.68824 15.9995 2.68799ZM13.437 12.7505L6.87451 13.2505L11.8745 17.563L10.3745 23.9995L15.9995 20.6255L21.6255 23.9995L20.1255 17.563L25.1255 13.2505L18.563 12.688L15.9995 6.68799L13.437 12.7505Z"
      fill="url(#paint0_linear_58_23)"
    />
    <defs>
      <linearGradient id="paint0_linear_58_23" x1="14.6688" y1="30.3104" x2="14.6688" y2="2.68799" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF3700" />
        <stop offset="0.927885" stopColor="#FFA172" />
      </linearGradient>
    </defs>
  </svg>
);

const TierIcon = ({ tierLabel, size }) => {
  switch (tierLabel) {
    case 'Gold':
      return <GoldIcon size={size} />;
    case 'Silver':
      return <SilverIcon size={size} />;
    case 'Bronze':
      return <BronzeIcon size={size} />;
    case 'Base':
      return <BaseIcon size={size} />;
    default:
      return null;
  }
};

const TenantTierBadge = ({
  tenantTierId,
  size = 16,
  gap = 8,
  showLabel = true,
}) => {
  const label = getTenantTierLabel(tenantTierId);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap }}>
      {showLabel && <span>{label}</span>}
      <TierIcon tierLabel={label} size={size} />
    </span>
  );
};

export default TenantTierBadge;